import { AppointmentStatus } from '@gopeerproject/chuck';
export const getAppointmentColor = (color, status) => {
    switch (status) {
        case AppointmentStatus.Requested:
            return color.primary.solid;
        case AppointmentStatus.Confirmed:
        case AppointmentStatus.InProgress:
        case AppointmentStatus.Completed:
            return color.success.solid;
        case AppointmentStatus.Declined:
        case AppointmentStatus.Canceled:
        case AppointmentStatus.DidNotHappen:
            return color.negative.solid;
        case AppointmentStatus.Pending:
        default:
            return color.pending.solid;
    }
};
//# sourceMappingURL=appointment.js.map